<template>
    <div id="app">
        <RT />
    </div>
</template>
<script>
import RT from "./components/RouterView";
export default {
    name: "App",
    components: {
        RT
    }
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/App.vue